import { get, post } from '@/plugins/axios'
import { res } from './login'
import { MembershipAutomaticRenewal } from './interface/settlement'
import { CustomerOverviewRespDTO, DeliveryAbnormalOrderCount, GetCustomerShopDTO } from './interface/customer'

/**
* 会员配置-会员套餐列表
*/
export function getVipCombo () {
  return get('/settlement/membership/configure/template/price/select/list')
}

/**
* 站点会员列表
* @param {Object} params
*/
export function getAvailableVipTemplate (params: any) {
  return get('/settlement/membership/configure/available/template', { params })
}

/**
* 会员配置-特殊会员套餐列表
*/
export function getVipSpecial () {
  return get('/settlement/membership/configure/template/price/select/special/list')
}

/**
* 会员配置-会员套餐查询详情
*/
export function getVipInfo (id: any) {
  return get('/settlement/membership/configure/template/price/getById/' + id)
}

/**
* 会员配置-会员套餐查询详情
*/
export function promotionDetail (data: any) {
  return post('/smc/app/promotion/detail', data)
}

/**
* 会员配置-推荐身份查询
*/
export function superCustomerId (data: any) {
  return post('/smc/proRule/get/superCustomerId', data)
}

/**
* 获取用户是否自动续费状态
* @param {Object} data
*/
export const getAutomaticToggleStaus = (data: any) : Promise<res<MembershipAutomaticRenewal>> => {
  return post('/settlement/wallet/recharge/membership/getAutomaticToggleStaus', data)
}

/**
* 会员开启/关闭自动续费（前台）
* @param {Object} data
*/
export function automaticToggle (data: any) {
  if (!data.automaticRenewalStytle) return Promise.resolve({})
  return post('/settlement/wallet/recharge/membership/automaticToggle', data)
}

/**
 * 关闭前填写用户问卷
 * @param json 问卷内容
 */
export const closeAutoQuest = (json:string) => {
  return post('/customer/closeAutorenewQuestionnaire', { questionnaire: json })
}

/**
* 手动余额充值（前台）
*/
export function rechargeMembership (data: any) {
  return post('/settlement/wallet/recharge/membership/manual', data)
}

/**
* D2C|B2B前端-我的频道-我收藏的商品: 收藏列表
* @param {Object} data
*/
export function goodsProductList (data: any) {
  return post('/goods/favorite/product/list', data)
}

/**
* D2C|B2B前端-我的频道-我收藏的店铺: 收藏列表
* @param {Object} data
*/
export function goodsShopList (data: any) {
  return post('/goods/favorite/shop/list', data)
}

/**
* D2C|B2B前端 - 我的频道 - 商品足迹列表
* @param {Object} data
*/
export function goodsFootprintProduct (data: any) {
  return post('/goods/footprint/footprint/product', data)
}

/**
* D2C|B2B前端 - 我的频道 - 店铺足迹列表
* @param {Object} data
*/
export function goodsFootprintShop (data: any) {
  return post('/goods/footprint/footprint/shop', data)
}

/**
*  收藏商品
* @param {Object} data
*/
export function goodsProductAdd (params: any) {
  return get('/goods/favorite/product/add', { params })
}

/**
*  收藏商品
* @param {Object} data
*/
export function goodsProductCancel (params: any) {
  return get('/goods/favorite/product/cancel', { params })
}

/**
* 收藏店铺
* @param {Object} params
*/
export function goodsShopAdd (params: any) {
  return get('/goods/favorite/shop/add', { params })
}

/**
* 店铺行为记录-喜欢不喜欢
* @param {Object} data
*/
export function goodsProductSetting (data: any) {
  return post('/goods/product', data)
}

/**
* 商品行为记录-喜欢不喜欢
* @param {Object} data
*/
export function goodsShopSetting (data: any) {
  return post('/goods/shop', data)
}

/**
* 是否收藏 商品列表
* @param {Object} params
*/
export function isFavoritesList (params: any) {
  return get('/goods/favorite/product/isFavorites', { params })
}

/**
* 私有消息分页查询
* @param {Object} params
*/
export function getInformation (params: any) {
  return get('/customer/notify/private/query', { params })
}

/**
* 私有消息全部已读
*/
export function readAll () {
  return post('/customer/notify/private/read/all')
}

/**
* 私有消息已读
* @param {Object} data
*/
export function readRow (data: any) {
  return post('/customer/notify/private/read', data)
}

/**
* 是否预充会员
* @param {Object} data
*/
export function getPrecharegeOrderApi (params: any) {
  return get('/settlement/membership/configure/getPrecharegeOrder', { params })
}

/**
* 是否第一次充值会员
* @param {Object} data
*/
export function isFirstPayVipApi (params: any) {
  return get('/customer/getCustomerIsNewMembership', { params })
}

/**
* 获取店铺采购配置信息
*/
export function getShopPurchase () {
  return get('/customer/customer/shop/getShopPurchase')
}

/**
* 更新店铺采购配置信息
* @param {Object} data
*/
export function updateShopPurchase (data: any) {
  return post('/customer/customer/shop/updateShopDelivery', data)
}

/**
* 获取未读账单通知
* @param {Object} data
*/
export function userBillNotify () {
  return get('/settlement/bill/notify/query/unread')
}

/**
* 未读账单已读
* @param {Object} data
*/
export function readBillNotify (data: any) {
  return get('/settlement/bill/notify/read', data)
}

/** 获取账户概览-当前店铺-工作台新 */
export const getOverviewWorkbenchInfoApi = (data: GetCustomerShopDTO): Promise<res<CustomerOverviewRespDTO>> => {
  return post('/customer/getCustomerOverviewWorkbenchInfo', data)
}

/** 工作台订单数量，异常订单数量统计 */
export const workbenchOrderCoountApi = (data: any): Promise<res<DeliveryAbnormalOrderCount>> => {
  return get('/order/abnormalOrder/countWorkBrenchOrderCount', data)
}

/** 获取心愿单列表（前台，可购买筛选） */
export const getchoiceProductListApi = (data: {canOrder?:number}): Promise<res> => {
  return post('/goods/productPhotoAlbum/wishlist/get', data)
}
